import { ActionCreator } from 'redux';
import { Dispatch, ThunkAction } from '../../../../../types/actions';
import { onLoadTemplatesFail } from './onLoadTemplatesFail';
import { getTemplatesFromRest } from '../store/templates/helpers/getTemplatesFromRest';
import { templatesSet } from '../store/templates/actions/templatesSet';
import { REST_LOAD_BOARDS_TEMPLATE_NUSER, REST_LOAD_BOARDS_TEMPLATES } from '../constants';
import { tabLoadStatusSet } from '../store/common/actions/tabLoadstatusSet';
import { TTabKey } from '../store/types';
import { IRestBoardForOpenDialog } from '../rest/types';
import Util from '../../../../../util/util';
import { PartLoader } from '../../../../../util/part_loader';
import { TTabLoadStatus } from '../store/common/types';

export const loadTemplates: ActionCreator<ThunkAction> =
(
    isForNewUser: boolean = false
) => {
    const action = (dispatch: Dispatch) => {
        dispatch(tabLoadStatusSet(TTabKey.templates, TTabLoadStatus.LOADING));

        const loader = new PartLoader();
        return loader.loadPart(
            Util.getApiUrl(isForNewUser? REST_LOAD_BOARDS_TEMPLATE_NUSER: REST_LOAD_BOARDS_TEMPLATES),
            '',
            (count: number) => {
                //console.log('loaded', count);
            }
        )
        .then(
            (templatesRest: IRestBoardForOpenDialog[]) => {
                const templates = getTemplatesFromRest(templatesRest)
                dispatch(templatesSet(templates));
                dispatch(tabLoadStatusSet(TTabKey.templates, TTabLoadStatus.COMPLETED));
            }
        )
        .catch((err) => {
                console.error(err);
                dispatch(onLoadTemplatesFail())
            }
        );
    }
    return action;
};
